import { render, staticRenderFns } from "./FaqAccordeon.vue?vue&type=template&id=1448ee5b&scoped=true&"
import script from "./FaqAccordeon.vue?vue&type=script&lang=js&"
export * from "./FaqAccordeon.vue?vue&type=script&lang=js&"
import style0 from "./FaqAccordeon.vue?vue&type=style&index=0&id=1448ee5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448ee5b",
  null
  
)

export default component.exports